module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-solid-07ed56bf24344235e120623c43d430f9.svg";